import httpClient from '../axios/index';

class sessionService {
  refreshToken(refreshToken) {
    return httpClient.post('api/account/refresh', { refreshToken });
  }
}

export default new sessionService();
